import React from 'react';
import SpotAWheel from './components/SpotAWheel';
import 'antd/dist/antd.css';

function App() {
  return (
    <div>
      <SpotAWheel />
    </div>
  );
}

export default App;
